import React from 'react'
import PropTypes from 'prop-types'
import Button from '../../ui/Button'
import WarningModal from './WarningModal'

const BODY_CLASS = 'tw:m-0! tw:text-sm tw:text-gray-500 tw:text-center'

const DiscardChangesModal = ({ isOpen, onCancel, onConfirm }) => {
  const footer = (
    <>
      <Button variant="neutral" onClick={onCancel}>Continuer l’édition</Button>
      <Button variant="destructive" onClick={onConfirm}>Annuler les modifications</Button>
    </>
  )

  return (
    <WarningModal footer={footer} isOpen={isOpen} title="Abandonner les modifications ?" onClose={onCancel}>
      <p className={BODY_CLASS}>Les modifications apportées aux statuts ne seront pas sauvegardées.</p>
    </WarningModal>
  )
}

DiscardChangesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
}

export default DiscardChangesModal
